module.exports = __webpack_public_path__ + "img/20190715153824096.505847b4.png";